import * as types from '@/store/mutation-types'
import apolloClient from '@/api/apollo'

import FETCH_EVENT from '@/graphql/queries/EventDialog/FetchEvent.graphql'

import moment from 'moment'
moment.locale('es-do')

const namespaced = true

const state = {
  event: null
}

const getters = {
  event: (state, getters) => (now) => {
    if (!state.event) {
      return null
    }
    const gsm = state.event.data.gsm ? {
      signal: state.event.data.gsm.signal,
      registration: state.event.data.gsm.registration,
      codeCountry: state.event.data.gsm.codeCountry,
      codeNetwork: state.event.data.gsm.codeNetwork,
      baseStationCode: state.event.data.gsm.baseStationCode,
      baseStationIdentifier: state.event.data.gsm.baseStationIdentifier,
      strengthSignal: state.event.data.gsm.strengthSignal
    } : null
    return {
      vehiclePlate: state.event.vehicle.plate,
      name: state.event.name,
      date: getters.humanDate(state.event.data.gps.date, now),
      engineState: state.event.engineState,
      gps: {
        speed: state.event.data.gps.speed,
        azimuth: state.event.data.gps.azimuth.grades,
        satellites: state.event.data.gps.satellites,
        hdop: state.event.data.gps.hdop,
        vdop: state.event.data.gps.vdop,
        latitude: state.event.data.gps.latitude,
        longitude: state.event.data.gps.longitude,
        altitude: state.event.data.gps.altitude
      },
      gsm,
      reverseGeocoding: state.event.reverseGeocoding,
      batteryLevel: state.event.data.adc.voltagePowerExternal,
      backupBatteryLevel: state.event.data.adc.voltageBateryBackup
    }
  },
  notes: (state, getters) => (now) => {
    if (!state.vehicle) {
      return []
    }
    return state.vehicle.notes.map(({ _id, author, title, body, date }) => {
      return { _id, author: author.name, title, body, date: getters.humanDate(date, now) }
    })
  },
  humanDate: (state, getters) => (date, now) => {
    if (!date) {
      return 'nunca'
    }
    const isSameDay = moment(date).isSame(now, 'day')
    if (isSameDay) {
      return moment(date).from(now)
    }
    return moment(date).format('DD [de] MMMM [de] YYYY [a las] hh:mm:ss A').toLowerCase()
  }
}

const mutations = {
  [types.SET_EVENT] (state, { event }) {
    state.event = event
  }
}

const actions = {
  async fetchEvent ({ commit }, { eventId }) {
    const result = await apolloClient.query({
      query: FETCH_EVENT,
      variables: {
        eventId
      }
    })
    const event = result.data.fetchEventById
    if (!event) {
      throw new Error('Event not found')
    }
    commit(types.SET_EVENT, { event })
  }
}

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/event-dialog/index.js